module.exports = __webpack_public_path__ + "static/bidali-cashback-spanish-0d8230736874ef29de7c78b8043a63bc.jpg";